import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('app_container'+ ($options.appLoadingStore.isLoading ? ' loading' : ''))
  }, [
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmDialog),
    ($options.appLoadingStore.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _createVNode(_component_RouterView)
  ], 2))
}